<template>
  <div class="entity-disambiguation__item">
    <div class="disambiguation-item__text">
      <ELink
        color="result"
        class="disambiguation-item__title"
        :href="url"
        data-test-id="entity-disambiguation-item-title"
        :title="title"
      >
        {{ title }}
      </ELink>
      <p
        class="disambiguation-item__description"
        data-test-id="entity-disambiguation-item-description"
        :title="description"
      >
        {{ description }}
      </p>
    </div>

    <a
      v-if="thumbnailUrl"
      :href="url"
      tabindex="-1"
      aria-hidden="true"
    >
      <EThumbnail
        :src="thumbnailUrl"
        :alt="title"
        class="disambiguation-item__thumbnail"
      />
    </a>
  </div>
</template>

<script>
import ELink from '~~/common/vue/components/link';
import EThumbnail from '~~/common/vue/components/thumbnail';

export default {
  name: 'EEntityDisambiguationItem',
  components: {
    ELink,
    EThumbnail,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    thumbnailUrl: {
      type: String,
      required: false,
      default: undefined,
    },
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    url() {
      // TODO: expand getUrlQuery (common/js/universal/search.js) and use it here
      const query = ['canary', 'mocked', 'forceProvider', 'sfs', 'sfn', 'q'].reduce((acc, key) => {
        const value = this.$route.query[key];
        return value ? { ...acc, [key]: value } : acc;
      }, {});
      query.entity = this.id;
      return this.$router.resolve({ query }).href;
    },
  },
};
</script>

<style lang="scss" scoped>
$disambiguation-thumbnail-size: 50px;

.entity-disambiguation__item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: $space-s $space-m;
}

.entity-disambiguation__item:not(:last-child) {
  @include divider(bottom);
}

.disambiguation-item__text {
  min-width: 0;
  width: 100%;
}

.disambiguation-item__thumbnail {
  border-radius: $border-radius-l;
  margin-left: $space-s;
  overflow: hidden;
  height: $disambiguation-thumbnail-size;
  width: $disambiguation-thumbnail-size;
}

.disambiguation-item__thumbnail:hover {
  @include elevation(2);
}

.disambiguation-item__title {
  @extend %ellipsis;

  display: block;
}

.disambiguation-item__description {
  @include line-clamp(2);

  margin: $space-2s 0 0 0;
}
</style>
